(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fec-pack-final-conversion-block"] && !Shopify.designMode) return;
  try {
    
  class FxFinalConversionBlock {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('form[data-type="add-to-cart-form"]');
      this.variantInput = section.querySelector('[data-fx-final-variant-id]');

      this.bindVariantChange();
    }

    bindVariantChange() {
      document.addEventListener('variant:change', (event) => {
        const variant = event.detail && event.detail.variant;
        if (!variant || !this.variantInput) return;

        this.variantInput.value = variant.id;
      });
    }
  }

  document.querySelectorAll('.fx-final-conversion').forEach((section) => {
    new FxFinalConversionBlock(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fx-pack-close"] && !Shopify.designMode) return;
  try {
    
(function(){
document.addEventListener('submit',function(e){
var f=e.target.closest&&e.target.closest('[data-fx-add]');if(!f)return;
e.preventDefault();
var b=f.querySelector('button'),o=b.textContent;
b.disabled=true;b.textContent='Adding...';
fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
.then(function(r){if(!r.ok)throw new Error('add');return r.json()})
.then(function(){return fetch('/cart.js').then(function(r){return r.json()})})
.then(function(cart){b.textContent='Added';document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));setTimeout(function(){b.textContent=o;b.disabled=false},1800)})
.catch(function(){b.textContent=o;b.disabled=false;f.submit()});
});
})();
(function(){
var lastY=window.scrollY,was=false,stop=false;
function dr(){return document.querySelector('.ocu-cart-drawer')}
function isOpen(){var d=dr();return !!(d&&d.classList.contains('ocu-visible'))}
window.addEventListener('scroll',function(){if(!isOpen()&&!was)lastY=window.scrollY},{passive:true});
document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('.fx-modular-hero__atc,.fx-modular-hero__sticky-button,[data-fx-worth-atc]');if(b){lastY=window.scrollY;setTimeout(function(){b.blur()},0)}},true);
['wheel','touchstart','keydown'].forEach(function(n){window.addEventListener(n,function(){stop=true},{passive:true})});
function restore(){stop=false;var t0=Date.now();(function f(){if(stop||Date.now()-t0>900)return;if(Math.abs(window.scrollY-lastY)>40)window.scrollTo(0,lastY);requestAnimationFrame(f)})()}
new MutationObserver(function(){var o=isOpen();if(was&&!o)restore();was=o}).observe(document.documentElement,{attributes:true,childList:true,subtree:true,attributeFilter:['class']});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fx-pack-details-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.hasAttribute || !sel.hasAttribute('data-fx-select')) return;
    var root = sel.closest('.fx-dfaq');
    root.querySelectorAll('.fx-dfaq__panel').forEach(function (p) {
      p.hidden = p.getAttribute('data-fx-panel') !== sel.value;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fx-pack-proof-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function init(root) {
      if (root.__fxProof) return;
      root.__fxProof = true;
      var grid = root.querySelector('.fx-proof__grid');
      if (!grid) return;
      var cards = grid.querySelectorAll('.fx-proof__card');
      var dots = root.querySelectorAll('.fx-proof__dot');
      if (cards.length < 2) return;
      var interval = parseInt(root.getAttribute('data-fx-interval'), 10) || 5000;
      var paused = false, visible = true, resumeTimer = null, ticking = false;
      function pad() { return parseFloat(getComputedStyle(grid).paddingLeft) || 0; }
      function current() {
        var best = 0, bestD = Infinity;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(cards[i].offsetLeft - pad() - grid.scrollLeft);
          if (d < bestD) { bestD = d; best = i; }
        }
        return best;
      }
      function go(i) {
        grid.scrollTo({ left: cards[i].offsetLeft - pad(), behavior: reduce.matches ? 'auto' : 'smooth' });
      }
      function paint() {
        var c = current();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
      }
      function pause(ms) {
        paused = true;
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, ms);
      }
      grid.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(); });
      }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          go(parseInt(d.getAttribute('data-fx-dot'), 10));
          pause(9000);
        });
      });
      grid.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
      grid.addEventListener('touchend', function () { pause(7000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0.4 }).observe(root);
      }
      setInterval(function () {
        if (!mq.matches || paused || !visible || reduce.matches || document.hidden) return;
        go((current() + 1) % cards.length);
      }, interval);
    }
    function boot() { document.querySelectorAll('.fx-proof').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fx-pack-worth"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fx-worth-atc],[data-fx-worth-sub]');
    if (!a) return;
    e.preventDefault();
    if (a.hasAttribute('data-fx-worth-atc')) {
      var hero = document.querySelector('.fx-modular-hero__atc') || document.querySelector('.fx-modular-hero__sticky-button');
      if (hero) { hero.click(); } else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
      return;
    }
    function pick() {
      var w = document.querySelector('.appstle_sub_widget');
      var r = w && w.querySelector('input[name="selling_plan"]:not([value=""])');
      if (!r) return false;
      if (!r.checked) { var l = w.querySelector('label[for="' + r.id + '"]'); (l || r).click(); }
      return true;
    }
    function addSub() {
      var hero = document.querySelector('.fx-modular-hero__atc');
      if (hero) hero.click(); else window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (pick()) { setTimeout(addSub, 150); return; }
    var n = 0;
    var t = setInterval(function () {
      n++;
      if (pick()) { clearInterval(t); setTimeout(addSub, 150); return; }
      if (n > 12) { clearInterval(t); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    }, 250);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fx-product-pack-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function fmt(root, cents) {
      return (root.getAttribute('data-symbol') || '$') + (cents / 100).toFixed(2);
    }
    function apply(cartCents) {
      document.querySelectorAll('[data-fx-pup]').forEach(function (root) {
        var thr = parseInt(root.getAttribute('data-threshold'), 10) || 0;
        var pack = parseInt(root.getAttribute('data-pack-price'), 10) || 0;
        if (!thr) return;
        var withPack = cartCents + pack;
        var cartPct = Math.min(100, cartCents * 100 / thr);
        var withPct = Math.min(100, withPack * 100 / thr);
        var state = 'progress';
        var msg = root.getAttribute('data-msg-progress') || '';
        if (cartCents >= thr) { state = 'unlocked'; msg = root.getAttribute('data-msg-unlocked') || ''; }
        else if (withPack >= thr) { state = 'pack'; msg = root.getAttribute('data-msg-pack') || ''; }
        msg = msg.replace('{amount}', fmt(root, Math.max(0, thr - withPack)));
        root.classList.remove('is-progress', 'is-pack', 'is-unlocked');
        root.classList.add('is-' + state);
        var m = root.querySelector('[data-fx-pup-msg]'); if (m) m.textContent = msg;
        var f = root.querySelector('[data-fx-pup-fill]'); if (f) f.style.width = cartPct + '%';
        var p = root.querySelector('[data-fx-pup-proj]'); if (p) { p.style.left = cartPct + '%'; p.style.width = Math.max(0, withPct - cartPct) + '%'; }
        var b = root.querySelector('[data-fx-pup-bar]'); if (b) b.setAttribute('aria-valuenow', Math.round(cartPct));
      });
    }
    function refresh() {
      if (!document.querySelector('[data-fx-pup]')) return;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { apply(c.total_price || 0); })
        .catch(function () {});
    }
    if (window.__fxPupBound) return;
    window.__fxPupBound = true;
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function () {
        var a = arguments;
        var u = typeof a[0] === 'string' ? a[0] : (a[0] && a[0].url) || '';
        var p = origFetch.apply(this, a);
        if (/\/cart\/(add|change|update|clear)/.test(u)) {
          p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
        }
        return p;
      };
    }
    var origSend = XMLHttpRequest.prototype.send;
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) { this.__fxUrl = url; return origOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (/\/cart\/(add|change|update|clear)/.test(String(x.__fxUrl || ''))) {
        x.addEventListener('loadend', function () { setTimeout(refresh, 300); });
      }
      return origSend.apply(this, arguments);
    };
    ['cart:updated', 'cart:refresh', 'cart-updated', 'cart:change', 'ajaxProduct:added'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(refresh, 200); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  })();

  } catch(e) { console.error(e); }
})();
})();
